function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import * as React from 'react';
import PropTypes from 'prop-types';
import Checkbox from "./Checkbox";
import { css } from "../../styles/theme";
import { pure, compose, setDisplayName } from 'recompose';
import isEqual from 'lodash/isEqual';
import isUndefined from 'lodash/isUndefined';
import { LABEL_POSITION } from "./CheckboxBase";
function getOptions(options) {
  return options.map(function (option) {
    if (typeof option === 'string') {
      return {
        label: option,
        value: option
      };
    }
    return option;
  });
}
var CheckboxGroup = /*#__PURE__*/function (_React$Component) {
  function CheckboxGroup(props) {
    var _this;
    _classCallCheck(this, CheckboxGroup);
    _this = _callSuper(this, CheckboxGroup, [props]);
    _defineProperty(_this, "toggleOption", function (option) {
      var optionIndex = _this.state.value.indexOf(option.value);
      var value = _toConsumableArray(_this.state.value);
      if (optionIndex === -1) {
        value.push(option.value);
      } else {
        value.splice(optionIndex, 1);
      }
      if (!('value' in _this.props)) {
        _this.setState({
          value: value
        });
      }
      var onChange = _this.props.onChange;
      if (onChange) {
        onChange(value);
      }
    });
    _this.state = {
      value: props.value || props.defaultValue || []
    };
    return _this;
  }
  _inherits(CheckboxGroup, _React$Component);
  return _createClass(CheckboxGroup, [{
    key: "getChildContext",
    value: function getChildContext() {
      return {
        checkboxGroup: {
          toggleOption: this.toggleOption,
          value: this.state.value,
          disabled: this.props.disabled
        }
      };
    }
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      var value = nextProps.value;
      if (!isUndefined(value) && !isEqual(value, this.props.value)) {
        this.setState({
          value: value || []
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props = this.props,
        rootClassName = _this$props.rootClassName,
        checkboxRootClassName = _this$props.checkboxRootClassName,
        options = _this$props.options,
        disabled = _this$props.disabled,
        childrenAlt = _this$props.children,
        isVertical = _this$props.isVertical,
        labelPosition = _this$props.labelPosition,
        renderCheckbox = _this$props.renderCheckbox,
        shouldWrapText = _this$props.shouldWrapText,
        tabIndex = _this$props.tabIndex;
      var value = this.state.value;
      var children = childrenAlt;
      var style = {
        display: isVertical ? 'flex' : 'inline',
        whiteSpace: shouldWrapText ? 'normal' : 'nowrap'
      };
      if (options && options.length > 0) {
        children = getOptions(options).map(function (option, index) {
          return /*#__PURE__*/React.createElement(Checkbox, {
            key: option.value,
            disabled: !isUndefined(option.disabled) ? option.disabled : disabled,
            value: option.value,
            checked: value.indexOf(option.value) !== -1,
            onChange: function onChange() {
              return _this2.toggleOption(option);
            },
            rootClassName: checkboxRootClassName,
            style: style,
            tabIndex: tabIndex,
            labelPosition: labelPosition
          }, renderCheckbox ? renderCheckbox(_objectSpread(_objectSpread({}, option), {}, {
            index: index
          })) : option.label);
        });
      }
      return /*#__PURE__*/React.createElement("div", css(rootClassName), children);
    }
  }]);
}(React.Component);
_defineProperty(CheckboxGroup, "propTypes", {
  renderCheckbox: PropTypes.func,
  checkboxRootClassName: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  children: PropTypes.node,
  defaultValue: PropTypes.array,
  disabled: PropTypes.bool,
  isVertical: PropTypes.bool,
  labelPosition: PropTypes.oneOf(Object.keys(LABEL_POSITION)),
  shouldWrapText: PropTypes.bool,
  onChange: PropTypes.func,
  options: PropTypes.array.isRequired,
  rootClassName: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  value: PropTypes.array,
  tabIndex: PropTypes.number
});
_defineProperty(CheckboxGroup, "childContextTypes", {
  checkboxGroup: PropTypes.any
});
_defineProperty(CheckboxGroup, "defaultProps", {
  options: []
});
export default compose(setDisplayName('CheckboxGroup'), pure)(CheckboxGroup);